import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ButtonHeading, CommonInput, CustomPagination, CustomSelect, InvoiceStepperComponent } from 'components'
import { UserContext } from 'context';
import { getListDataForSelectClaims } from '_services/invoiceBillRaiseServices';
import StorageService from 'utils/StorageServices/StorageServices';
import { AddEditLrModal, ConfirmModalFor, LrDetailModal } from 'modals';
import { utils } from 'helper';

const SelectClaim = () => {

    const navigate = useNavigate()
    const shouldReloadRef = useRef(false);
    const { states, invoiceBillRaiseData, setInvoiceBillRaiseData } = useContext(UserContext)
    const [stateStatus, setStateStatus] = useState({});
    const [leaveShowConfirm, setLeaveShowConfirm] = useState(false);

    const [checkedBillRaiseLr, setCheckedBillRaiseLr] = useState(invoiceBillRaiseData?.select_claim_ids)

    const [claimList, setClaimList] = useState([])
    const [loading, setLoading] = useState(false);

    const [showAddLR, setShowAddLR] = useState(false);
    const [showLrDetail, setShowLrDetail] = useState(false)

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
        select_claim_ids: []
    });

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!shouldReloadRef.current) {
                event.preventDefault();
                event.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const claimListData = async () => {
        setLoading(true);
        try {
            let object = {
                ...filter,
                company_id: StorageService.getCompanyId(),
                consignor_id: invoiceBillRaiseData?.consignor_id?.value ? invoiceBillRaiseData?.consignor_id?.value : '',
            }
            const res = await getListDataForSelectClaims(object);
            if (res?.responseCode == 200) {
                setLoading(false);
                setClaimList(res?.data?.list);
                setTotalItems(res?.data?.total_record);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        claimListData();
    }, [filter])

    const discardHandlerFunction = (e) => {
        e.preventDefault();
        setLeaveShowConfirm(true);
    }

    const submitLeaveModalProps = () => {
        navigate('/invoicing')
    }

    let leaveModalProps = {
        show: leaveShowConfirm,
        closeModal: (e) => setLeaveShowConfirm(!leaveShowConfirm),
        title: "Leave This Page",
        submitTitle: "Confirm",
        onSubmit: submitLeaveModalProps,
        confirmModal: "confirmModal",
    };

    const listCheckboxHandle = async (id) => {
        let data = [...checkedBillRaiseLr];
        let values = data?.includes(id) ? data?.filter((item) => item !== id) : [...data, id]
        setCheckedBillRaiseLr(values);
    };

    const handleSelectLrSteper = async (e) => {
        e.preventDefault();
        if (checkedBillRaiseLr?.length > 0) {
            setInvoiceBillRaiseData((s) => ({ ...s, select_claim_ids: checkedBillRaiseLr, state: stateStatus }));
            navigate('/invoicing/selected_claims');
        }
    }

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const handleNextModal = (data) => {
        setShowLrDetail(!showLrDetail);
        setShowAddLR(data);
    }

    const handleDetailsAction = (data) => {
        setShowLrDetail(data);
    }

    return (
        <>
            <InvoiceStepperComponent
                headingName="Select Claims"
                greenTickNumber={2}
                isClaim={true}
            />

            <div className='_blRaise_fitsTop'>
                <div className="_fleX_inds _blRaise_fits">
                    <div className="_divForth">
                        <CommonInput
                            type="text"
                            placeholder="Party Name"
                            label="Party Name"
                            name='name'
                            value={invoiceBillRaiseData?.consignor_id?.label ? invoiceBillRaiseData?.consignor_id?.label : ''}
                            disabled={true}
                        />
                    </div>

                    {
                        invoiceBillRaiseData?.receiving_state?.label ? <div className="_divForth">
                            <CommonInput
                                type="text"
                                placeholder="Receiving State"
                                label="Receiving State *"
                                name='state'
                                value={invoiceBillRaiseData?.receiving_state?.label ? invoiceBillRaiseData?.receiving_state?.label : ''}
                                disabled={true}
                            />
                        </div> :
                            <div className="_divForth">
                                <CustomSelect
                                    label="All States"
                                    placeholder="All States"
                                    options={states?.length > 0 ? states?.map((el) => {
                                        return {
                                            ...el,
                                            label: el?.name,
                                            value: el?.name,
                                        }
                                    }) : []}
                                    name="state"
                                    value={stateStatus}
                                    onSelect={(data) => setStateStatus(data)}
                                />
                            </div>
                    }
                </div>
            </div>

            <div className='_tabWith_invoiceTab __selectedClaims'>
                <div>
                    <div className="_tab_htLane">
                        <div className="anv_fr_detailHead">
                            <table className="_trpTable_xd">
                                <thead className="table_head_style">
                                    <tr>
                                        <th></th>
                                        <th>LR Number</th>
                                        <th>Party Name</th>
                                        <th>Voucher No.</th>
                                        <th>From Station</th>
                                        <th>To Station</th>
                                        <th>Claim Name</th>
                                        <th>Description</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? <tr>
                                        <td><span className="_tblText"> Loading... </span></td>
                                    </tr> : (claimList?.length > 0 ? claimList?.map((rowData, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    id={`checkbox-${rowData?._id}`}
                                                    checked={checkedBillRaiseLr?.includes(rowData?._id)}
                                                    onChange={(e) => listCheckboxHandle(rowData._id)}
                                                />
                                                <label htmlFor={`checkbox-${rowData._id}`} > <span className='_invisibleSpan'>.</span> </label>
                                            </td>
                                            <td>
                                                <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction({ ...rowData?.lr, consignor_id: rowData?.vendor_detail?._id })}> <a className='_avPointer'> {rowData?.lr?.lr_number ? rowData?.lr?.lr_number : '-'} </a> </div>
                                            </td>
                                            <td>
                                                <div className='_tblText _lrNums'> <Link className='_avPointer' to={`/account/consignor/details/${rowData?.vendor_detail?._id}`}> {rowData?.vendor_detail?.name ? rowData?.vendor_detail?.name : '-'} </Link> </div>
                                            </td>
                                            <td>{rowData?.voucher_no ? rowData?.voucher_no : '-'}</td>
                                            <td>{rowData?.lr?.from_location ? rowData?.lr?.from_location : '-'}</td>
                                            <td>{rowData?.lr?.to_location ? rowData?.lr?.to_location : '-'}</td>
                                            <td>
                                                {rowData?.categories?.length > 0 ? rowData?.categories?.map((el) => {
                                                    return (
                                                        <>{el?.category?.name}</>
                                                    )
                                                }) : '-'}
                                            </td>
                                            <td>{rowData?.description ? utils.spliceString(rowData?.description, 0, 13) : '-'} </td>
                                            <td>{rowData?.total_amount ? (rowData?.total_amount).toFixed(2) : '-'}</td>
                                        </tr>
                                    )) :
                                        <tr>
                                            <td><span className="_tblText">No data</span></td>
                                        </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {claimList?.length > 0 && <div className='paginationFt_avt mb-5'>
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={filter.offset}
                        onPageChange={handlePageChange}
                    />
                </div>}
            </div>

            <div className='_billRaiseFooter'>
                <div className='prevDiscard_bx'>
                    <button className='_previousBtn' onClick={(e) => navigate('/invoicing/createbillraise')}><span>Previous</span></button>
                    <button className='_discardBtn' onClick={(e) => discardHandlerFunction(e)}><span>Discard</span></button>
                </div>

                <div>
                    <button
                        className='_stepSuccessBtn'
                        disabled={checkedBillRaiseLr?.length === 0}
                        onClick={(e) => handleSelectLrSteper(e)}
                    >
                        Next : Selected Claims
                    </button>
                </div>
            </div>

            {leaveShowConfirm && (
                <ConfirmModalFor {...leaveModalProps}>
                    <>
                        <p className="_confirmPrx"> Do you really want leave this Page ?</p>
                    </>
                </ConfirmModalFor>
            )}

            <div
                className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showLrDetail ? 'visible' : 'hidden' }}
            >
                {showLrDetail
                    && (
                        <LrDetailModal
                            isOpen={showLrDetail}
                            onClose={(e) => setShowLrDetail(false)}
                            nextModal={(e) => handleNextModal(e)}
                        />
                    )
                }
            </div>
            <div className={showLrDetail ? 'offBack_drop' : ''}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showAddLR ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showAddLR ? 'visible' : 'hidden' }}
            >
                {showAddLR
                    && (
                        <AddEditLrModal isOpen={showAddLR} onClose={() => setShowAddLR(false)} />
                    )
                }
            </div>
            <div className={showAddLR ? 'offBack_drop' : ''}></div>
        </>
    )
}

export default SelectClaim